import {
  GLOBALS_SELECTED_SEDE_SET,
} from './types';

const initialState = null;

const selectedSedeReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case GLOBALS_SELECTED_SEDE_SET: {
      return actions.sede || null;
    }

    default:
      return state;
  }
};

export default selectedSedeReducer;
